function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs34"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -405.26,
  x2: -403.76,
  y1: -319.09,
  y2: -319.09
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop10",
  stopColor: "#e5e5e6",
  offset: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop12",
  stopColor: "#fff",
  offset: 0.86
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -9328.4,
  x2: -9290.8,
  y1: -5731.2,
  y2: -5731.2,
  gradientTransform: "matrix(.99996 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: -9718.3,
  x2: -9680.8,
  y1: -6118.1,
  y2: -6118.1,
  gradientTransform: "matrix(.99998 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: -9959.7,
  x2: -9922.1,
  y1: -6120.7,
  y2: -6120.7,
  gradientTransform: "matrix(.99998 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: -9191.4,
  x2: -9153.9,
  y1: -6371.2,
  y2: -6371.2,
  gradientTransform: "matrix(.99997 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: -9142.8,
  x2: -9105.3,
  y1: -6096.9,
  y2: -6096.9,
  gradientTransform: "translate(-152,-1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: -9453.3,
  x2: -9415.8,
  y1: -6462.1,
  y2: -6462.1,
  gradientTransform: "matrix(.99998 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: -9645.7,
  x2: -9608.2,
  y1: -6477.5,
  y2: -6477.5,
  gradientTransform: "matrix(.99999 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: -20.847,
  x2: -20.406,
  y1: -4.11,
  y2: -4.11
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop22",
  stopColor: "#e5e5e6",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop24",
  stopColor: "#fff",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: -2635.7,
  x2: -2570.1,
  y1: 1424.9,
  y2: 1424.9,
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: -2369.9,
  x2: -2304.3,
  y1: 1425.2,
  y2: 1425.2,
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: -2288.6,
  x2: -2222.9,
  y1: 1311,
  y2: 1311,
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: -2319.7,
  x2: -2254.1,
  y1: 1654.9,
  y2: 1654.9,
  gradientTransform: "matrix(1 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: -2455.1,
  x2: -2389.4,
  y1: 1616.7,
  y2: 1616.7,
  gradientTransform: "matrix(1 0 0 1 -151.66 -1026.7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "o",
  x1: -2190.3,
  x2: -2124.6,
  y1: 1606.3,
  y2: 1606.3,
  gradientTransform: "scale(1)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "p",
  x1: -2133.7,
  x2: -2068.1,
  y1: 1484.5,
  y2: 1484.5,
  gradientTransform: "scale(1)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2414",
  x1: -9452.1,
  x2: -9414.5,
  y1: -6029,
  y2: -6029,
  gradientTransform: "matrix(.99998 0 0 1 -152 -1027)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient2416",
  x1: -2504.3,
  x2: -2438.7,
  y1: 1467.4,
  y2: 1467.4,
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#i"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect36",
  width: 1566,
  height: 1299
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#bcbec0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  id: "path38",
  d: "m345.2 375.46a299.01 299.01 0 0 1 175.32-56.451c165.88 0 300.36 134.48 300.36 300.36s-134.48 300.36-300.36 300.36a299.02 299.02 0 0 1-179.45-59.477"
}), /*#__PURE__*/React.createElement("line", {
  id: "line40",
  x1: 519.53,
  x2: 519.53,
  y1: 919.73,
  y2: 1081.9
}), /*#__PURE__*/React.createElement("line", {
  id: "line42",
  x1: 513.15,
  x2: 513.15,
  y1: 156.7,
  y2: 318.91
}), /*#__PURE__*/React.createElement("line", {
  id: "line44",
  x1: 697.59,
  x2: 792.94,
  y1: 861.75,
  y2: 992.98
}), /*#__PURE__*/React.createElement("line", {
  id: "line46",
  x1: 806.98,
  x2: 961.25,
  y1: 710.6,
  y2: 760.72
}), /*#__PURE__*/React.createElement("line", {
  id: "line48",
  x1: 249.68,
  x2: 345.03,
  y1: 243.99,
  y2: 375.22
}), /*#__PURE__*/React.createElement("line", {
  id: "line50",
  x1: 802.74,
  x2: 957.01,
  y1: 512.79,
  y2: 462.67
}), /*#__PURE__*/React.createElement("line", {
  id: "line52",
  x1: 690.31,
  x2: 785.66,
  y1: 371.37,
  y2: 240.14
}), /*#__PURE__*/React.createElement("line", {
  id: "line54",
  x1: 245.82,
  x2: 341.16,
  y1: 991.37,
  y2: 860.14
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "path56",
  d: "m532.85 936.07a22.667 22.667 0 1 1 5.015-31.661 22.669 22.669 0 0 1-5.015 31.661z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("path", {
  id: "path58",
  d: "m526.86 927.82a12.475 12.475 0 1 1 2.758-17.425 12.478 12.478 0 0 1-2.758 17.425z",
  fill: "url(#linearGradient2414)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path60",
  d: "m360.65 873.56a22.667 22.667 0 1 1-3.079-31.908 22.67 22.67 0 0 1 3.079 31.908z",
  fill: "#ffe8a6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path62",
  d: "m352.79 867.07a12.475 12.475 0 1 1-1.7-17.56 12.48 12.48 0 0 1 1.7 17.56z",
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path64",
  d: "m710.91 880.09a22.668 22.668 0 1 1 5.016-31.661 22.67 22.67 0 0 1-5.016 31.661z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path66",
  d: "m704.92 871.84a12.475 12.475 0 1 1 2.758-17.426 12.478 12.478 0 0 1-2.758 17.426z",
  fill: "url(#c)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path68",
  d: "m813.4 732.02a22.667 22.667 0 1 1 13.995-28.842 22.671 22.671 0 0 1-13.995 28.842z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path70",
  d: "m810.07 722.38a12.475 12.475 0 1 1 7.7-15.873 12.479 12.479 0 0 1-7.7 15.873z",
  fill: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path72",
  d: "m526.47 301.55a22.667 22.667 0 1 0 5.014 31.661 22.67 22.67 0 0 0-5.014-31.661z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path74",
  d: "m520.48 309.8a12.475 12.475 0 1 0 2.759 17.426 12.479 12.479 0 0 0-2.759-17.426z",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path76",
  d: "m364.11 364.01a22.666 22.666 0 1 0-6.845 31.315 22.67 22.67 0 0 0 6.845-31.315z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path78",
  d: "m355.53 369.51a12.476 12.476 0 1 0-3.769 17.235 12.476 12.476 0 0 0 3.769-17.235z",
  fill: "url(#f)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path80",
  d: "m702.64 354.94a22.667 22.667 0 1 0 5.014 31.661 22.669 22.669 0 0 0-5.014-31.661z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("path", {
  id: "path82",
  d: "m696.64 363.18a12.475 12.475 0 1 0 2.758 17.425 12.477 12.477 0 0 0-2.758-17.425z",
  fill: "url(#g)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path84",
  d: "m809.24 491.08a22.667 22.667 0 1 0 15.221 28.213 22.671 22.671 0 0 0-15.221-28.213z",
  fill: "#ffe8a6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path86",
  d: "m806.32 500.84a12.475 12.475 0 1 0 8.375 15.529 12.477 12.477 0 0 0-8.375-15.529z",
  fill: "url(#h)"
}));

var _ref5 = /*#__PURE__*/React.createElement("text", {
  id: "text94",
  x: 162.12,
  y: 1153.3669,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan88",
  x: 162.12,
  y: 1153.3669
}, "Aitame tehingu"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan92",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan90",
  x: 162.12,
  y: 1174.967
}, "vormistamisel")));

var _ref6 = /*#__PURE__*/React.createElement("text", {
  id: "text102",
  x: 163.12,
  y: 86.464996,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "18px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan96",
  x: 163.12,
  y: 86.464996
}, "Teavita meid"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan100",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan98",
  x: 163.12,
  y: 108.065
}, "m\xFC\xFCgisoovist")));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path128",
  d: "m767.91 261.19a74.386 74.386 0 1 1 104.22-14.29 74.385 74.385 0 0 1-104.22 14.29z",
  fill: "url(#m)",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "path132",
  d: "m960.42 515.64a74.386 74.386 0 1 1 104.22-14.287 74.383 74.383 0 0 1-104.22 14.287z",
  fill: "url(#n)",
  fillRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "i1_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "path134",
  d: "m1047.8 399.8a70.684 70.684 0 1 1-99.033 13.576 70.76 70.76 0 0 1 99.033-13.576zm-78.207 103.05a58.684 58.684 0 1 0-11.267-82.222 58.752 58.752 0 0 0 11.267 82.225z",
  fill: "#fee7a6"
}), /*#__PURE__*/React.createElement("g", {
  id: "g168",
  transform: "translate(43.383 -773.82)",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path148",
  d: "m966.16 1272.5h-0.054l-9.572-0.773a0.658 0.658 0 0 1-0.5-1l5.134-8.2a0.649 0.649 0 0 1 0.587-0.308 0.657 0.657 0 0 1 0.555 0.363l4.443 8.972a0.655 0.655 0 0 1-0.589 0.947zm-8.444-2 7.341 0.594-3.407-6.88z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path150",
  d: "m962.15 1272.2a0.309 0.309 0 0 1-0.053 0l-5.567-0.446a0.656 0.656 0 0 1-0.535-0.36 0.663 0.663 0 0 1 0.029-0.643l3-4.8a0.658 0.658 0 0 1 0.929-0.194 6.641 6.641 0 0 1 2.184 2.514 6.558 6.558 0 0 1 0.667 3.315 0.655 0.655 0 0 1-0.655 0.614zm-4.44-1.671 3.785 0.3a5.274 5.274 0 0 0-0.533-1.98 5.217 5.217 0 0 0-1.21-1.59z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path152",
  d: "m966.16 1272.5h-0.054l-9.572-0.773a0.658 0.658 0 0 1-0.5-1l5.134-8.2a0.643 0.643 0 0 1 0.263-0.241l30.139-14.9a0.654 0.654 0 0 1 0.878 0.3l4.443 8.977a0.658 0.658 0 0 1-0.3 0.879l-1.063 0.522-29.075 14.377a0.666 0.666 0 0 1-0.293 0.059zm-8.444-2 8.316 0.672 28.914-14.3 0.473-0.231-3.859-7.8-1.089 0.538-28.3 13.992z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path154",
  d: "m966.28 1261.3h-26a0.656 0.656 0 0 1-0.656-0.656v-64.169a0.657 0.657 0 0 1 0.656-0.657h47.288a0.655 0.655 0 0 1 0.655 0.657v53.645a0.656 0.656 0 0 1-0.364 0.59l-21.284 10.522a0.665 0.665 0 0 1-0.295 0.068zm-25.346-1.312h25.193l20.782-10.275v-52.582h-45.975z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path156",
  d: "m978.18 1217.4h-28.536a0.657 0.657 0 0 1 0-1.313h28.536a0.6565 0.6565 0 1 1 0 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path158",
  d: "m965.5 1227.3h-15.852a0.656 0.656 0 0 1 0-1.312h15.852a0.656 0.656 0 1 1 0 1.312z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path160",
  d: "m973.53 1237.2h-23.883a0.656 0.656 0 0 1 0-1.312h23.883a0.656 0.656 0 1 1 0 1.312z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path162",
  d: "m971.69 1247h-22.043a0.656 0.656 0 0 1 0-1.312h22.043a0.656 0.656 0 1 1 0 1.312z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path164",
  d: "m979.53 1265.9a0.673 0.673 0 0 1-0.27-0.058 0.656 0.656 0 0 1-0.363-0.428l-2.645-9.861a0.657 0.657 0 0 1 0.344-0.756l5.133-2.542a0.655 0.655 0 0 1 0.923 0.418l2.648 9.868a0.652 0.652 0 0 1-0.344 0.756l-5.135 2.536a0.659 0.659 0 0 1-0.291 0.067zm-1.869-10.166 2.3 8.567 3.935-1.941-2.3-8.572z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path166",
  d: "m996.3 1257.6a0.654 0.654 0 0 1-0.588-0.364l-4.443-8.978a0.658 0.658 0 0 1-0.034-0.5 0.648 0.648 0 0 1 0.331-0.377l2.5-1.234a2.164 2.164 0 0 1 0.973-0.228 2.227 2.227 0 0 1 1.986 1.233l3.064 6.189a2.212 2.212 0 0 1-1 2.959l-2.5 1.233a0.647 0.647 0 0 1-0.289 0.067zm-3.565-9.336 3.861 7.8 1.907-0.942a0.9 0.9 0 0 0 0.454-0.521 0.881 0.881 0 0 0-0.046-0.678l-3.065-6.193a0.9 0.9 0 0 0-0.81-0.5 0.874 0.874 0 0 0-0.391 0.091z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "i1_1"
}, /*#__PURE__*/React.createElement("g", {
  id: "g2660"
}, /*#__PURE__*/React.createElement("g", {
  id: "g146",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path142",
  d: "m313.29 1284.9a74.386 74.386 0 1 1 104.64 10.856 74.384 74.384 0 0 1-104.64-10.856z",
  fill: "url(#p)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "path144",
  d: "m425.91 1193.5a70.684 70.684 0 1 1-99.425-10.315 70.764 70.764 0 0 1 99.425 10.315zm-100.43 81.544a58.684 58.684 0 1 0 8.57-82.547 58.753 58.753 0 0 0-8.57 82.547z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "g182",
  transform: "translate(-152,-1027)",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path170",
  d: "m358.8 1216.1h-19.859a0.667 0.667 0 1 1 0-1.334h19.859a0.667 0.667 0 1 1 0 1.334z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path172",
  d: "m357.17 1222.8h-18.232a0.667 0.667 0 1 1 0-1.334h18.232a0.667 0.667 0 1 1 0 1.334z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path174",
  d: "m351.37 1229.6h-12.429a0.6675 0.6675 0 1 1 0-1.335h12.429a0.6675 0.6675 0 1 1 0 1.335z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path176",
  d: "m359.84 1237.9a0.669 0.669 0 0 1-0.334-0.089l-5.664-3.269h-20.416a2.975 2.975 0 0 1-2.974-2.971v-19.405a2.975 2.975 0 0 1 2.974-2.97h28.964a2.973 2.973 0 0 1 2.969 2.97v19.405a2.974 2.974 0 0 1-2.969 2.971h-1.886v2.623c0 0.021 5e-3 0.045 5e-3 0.067a0.669 0.669 0 0 1-0.669 0.668zm-26.414-27.369a1.639 1.639 0 0 0-1.639 1.635v19.405a1.638 1.638 0 0 0 1.639 1.635h20.6a0.643 0.643 0 0 1 0.332 0.091l4.817 2.779v-2.2a0.666 0.666 0 0 1 0.667-0.67h2.554a1.636 1.636 0 0 0 1.635-1.635v-19.405a1.638 1.638 0 0 0-1.635-1.635z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path178",
  d: "m385.56 1241.1a14.447 14.447 0 1 1 14.459-14.45 14.472 14.472 0 0 1-14.459 14.45zm0-27.558a13.111 13.111 0 1 0 13.123 13.108 13.131 13.131 0 0 0-13.123-13.111z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path180",
  d: "m407.88 1269.6h-44.636a0.668 0.668 0 0 1-0.668-0.667c0-6.625 2.494-12.191 7.216-16.1a25.919 25.919 0 0 1 31.536 0 20.144 20.144 0 0 1 7.216 16.031v0.068a0.668 0.668 0 0 1-0.664 0.668zm-43.962-1.335h43.281c-0.355-13.353-11.384-19.444-21.641-19.444s-21.284 6.091-21.64 19.444z"
}))));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "i1_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "g140",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path136",
  d: "m619.81 1198.4a74.386 74.386 0 1 1 104.22-14.289 74.384 74.384 0 0 1-104.22 14.289z",
  fill: "url(#o)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "path138",
  d: "m707.51 1082.9a70.684 70.684 0 1 1-99.034 13.575 70.761 70.761 0 0 1 99.034-13.575zm-78.211 103.05a58.684 58.684 0 1 0-11.265-82.223 58.752 58.752 0 0 0 11.265 82.223z",
  fill: "#5d752e"
})), /*#__PURE__*/React.createElement("g", {
  id: "g190",
  transform: "translate(-152,-1027)",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path184",
  d: "m649.49 1147.8a22.068 22.068 0 1 1 22.068-22.068 22.094 22.094 0 0 1-22.068 22.068zm0-42.866a20.8 20.8 0 1 0 20.8 20.8 20.821 20.821 0 0 0-20.8-20.801z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path186",
  d: "m633.14 1127.2a0.637 0.637 0 0 1-0.636-0.635 18.656 18.656 0 0 1 11.41-17.213 0.63501 0.63501 0 1 1 0.494 1.17 17.387 17.387 0 0 0-10.633 16.043 0.637 0.637 0 0 1-0.635 0.635z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path188",
  d: "m692.83 1172.5c-4.087 0-13.181-8.112-18.967-14.325-5.111-5.49-9.285-11.02-11.451-15.171l1.127-0.588c2.084 3.994 6.291 9.563 11.253 14.9 9.6 10.3 17.263 14.975 18.541 13.784s-2.836-9.171-12.43-19.476c-5.285-5.674-10.781-10.593-14.347-12.838l0.678-1.074c3.651 2.3 9.244 7.3 14.6 13.047 6.572 7.059 15.291 18.549 12.367 21.27a1.925 1.925 0 0 1-1.371 0.471z"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "i1_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path130",
  d: "m855.39 145.35a70.684 70.684 0 1 1-99.035 13.576 70.764 70.764 0 0 1 99.035-13.576zm-78.206 103.05a58.684 58.684 0 1 0-11.268-82.223 58.753 58.753 0 0 0 11.268 82.223z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g246",
  transform: "translate(-344.43 -1283.5)",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path192",
  d: "m1173.2 1519.7a1.713 1.713 0 0 1-0.746-0.208 23.661 23.661 0 0 1-5.512-4.543 29.84 29.84 0 0 0-5.188-4.447c-0.238-0.143-0.476-0.277-0.711-0.407-0.978-0.549-1.9-1.066-2.219-1.963a1.713 1.713 0 0 1-0.1-0.616 16.776 16.776 0 0 1 1.154-4.368c0.094-0.256 0.173-0.484 0.235-0.667a2.645 2.645 0 0 1 2.838-2.008h0.087c2.54 0 10.062 1.946 12.663 2.993 1.417 0.569 2.212 1.2 2.505 2 0.378 0.985-0.734 4.155-2.473 8.878-0.6 1.639-1.123 3.052-1.317 3.778-0.195 0.775-0.405 1.578-1.216 1.578zm-10.159-18.291c-1.585 0.041-1.837 0.781-2.038 1.373-0.063 0.187-0.147 0.419-0.24 0.682a16.777 16.777 0 0 0-1.1 4.053 0.844 0.844 0 0 0 0.039 0.294c0.2 0.574 0.943 0.988 1.8 1.468 0.242 0.134 0.488 0.273 0.736 0.421a30.63 30.63 0 0 1 5.366 4.586 23.047 23.047 0 0 0 5.266 4.369 0.7 0.7 0 0 0 0.342 0.11 3.11 3.11 0 0 0 0.3-0.878c0.2-0.772 0.732-2.2 1.342-3.864 0.965-2.616 2.758-7.488 2.476-8.226-0.191-0.529-0.839-1.007-1.976-1.463-2.527-1.018-9.941-2.925-12.313-2.925zm8.655 8.715a1.8 1.8 0 0 1-1.408-2.909 1.847 1.847 0 0 1 2.521-0.294 1.8 1.8 0 0 1-1.113 3.2zm0-2.65a0.88 0.88 0 0 0-0.682 0.328 0.839 0.839 0 0 0-0.176 0.62 0.858 0.858 0 0 0 1.516 0.446 0.847 0.847 0 0 0 0.191-0.642 0.829 0.829 0 0 0-0.316-0.568 0.86 0.86 0 0 0-0.529-0.185z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path194",
  d: "m1140.9 1519.7c-0.794 0-1-0.763-1.216-1.572-0.193-0.746-0.726-2.2-1.347-3.875-1.721-4.671-2.821-7.806-2.453-8.789a4.061 4.061 0 0 1 2.516-2c2.6-1.046 10.12-2.992 12.661-2.992h0.081a2.669 2.669 0 0 1 2.842 2c0.07 0.209 0.158 0.461 0.259 0.747a16.787 16.787 0 0 1 1.123 4.3 1.787 1.787 0 0 1-0.088 0.608c-0.3 0.888-1.224 1.4-2.2 1.947-0.24 0.135-0.488 0.273-0.732 0.421a29.817 29.817 0 0 0-5.194 4.449 23.623 23.623 0 0 1-5.513 4.542 1.678 1.678 0 0 1-0.739 0.214zm10.222-18.292c-2.434 0-9.848 1.908-12.371 2.924-1.131 0.453-1.783 0.934-1.994 1.469-0.272 0.723 1.5 5.54 2.459 8.129 0.628 1.7 1.168 3.172 1.374 3.955a3 3 0 0 0 0.313 0.885 0.849 0.849 0 0 0 0.327-0.111 23.054 23.054 0 0 0 5.268-4.368 30.551 30.551 0 0 1 5.371-4.587c0.254-0.153 0.51-0.3 0.756-0.435 0.85-0.476 1.582-0.886 1.773-1.44a0.889 0.889 0 0 0 0.034-0.3 16.754 16.754 0 0 0-1.069-3.991c-0.1-0.294-0.193-0.551-0.261-0.757-0.218-0.618-0.468-1.328-1.977-1.369zm-8.719 8.715a1.8 1.8 0 0 1-1.4-0.672 1.811 1.811 0 0 1 0.286-2.529 1.848 1.848 0 0 1 2.518 0.293 1.8 1.8 0 0 1 0.378 1.335 1.745 1.745 0 0 1-0.667 1.183 1.763 1.763 0 0 1-1.118 0.39zm-0.01-2.65a0.838 0.838 0 0 0-0.528 0.183 0.87 0.87 0 0 0-0.139 1.209 0.862 0.862 0 0 0 0.672 0.323 0.853 0.853 0 0 0 0.535-0.19 0.813 0.813 0 0 0 0.317-0.559 0.866 0.866 0 0 0-0.857-0.966z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path196",
  d: "m1175.5 1504.4a0.447 0.447 0 0 1-0.175-0.035c-2.527-1.016-9.941-2.924-12.313-2.924h-0.01a0.538 0.538 0 0 1-0.4-0.18 0.5 0.5 0 0 1-0.117-0.409c0.573-2.121 2.31-8.576 4.318-11.588 1.766-2.635 7.893-7.911 12.745-9.8 2.416-0.941 4.294-0.956 5.527-0.059a4.221 4.221 0 0 1 0.349 0.283 32.178 32.178 0 0 1 4.868-11.471c0.548-0.732 2-2.438 3.691-2.438a2.574 2.574 0 0 1 1.715 0.676c1.951 1.686 0.461 8.814-0.272 11.8-1.115 4.553-3.134 10.4-4.929 12.475a18.67 18.67 0 0 1-6.388 4.72c-2.907 1.494-5.65 2.905-8.182 8.667a0.467 0.467 0 0 1-0.431 0.283zm-11.956-3.873a61.474 61.474 0 0 1 11.709 2.81c2.613-5.728 5.441-7.18 8.427-8.716a17.891 17.891 0 0 0 6.109-4.5c1.428-1.653 3.418-6.736 4.728-12.087 1.375-5.608 1.6-9.977 0.568-10.871a1.636 1.636 0 0 0-1.1-0.447c-1.3 0-2.58 1.579-2.942 2.063a30.612 30.612 0 0 0-4.855 12.143 0.469 0.469 0 0 1-0.467 0.42 0.481 0.481 0 0 1-0.443-0.3 2.074 2.074 0 0 0-0.751-0.885c-0.962-0.7-2.559-0.636-4.64 0.174-4.612 1.8-10.642 6.97-12.3 9.447-1.778 2.664-3.365 8.255-4.043 10.749z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path198",
  d: "m1138.6 1504.4a0.469 0.469 0 0 1-0.43-0.28c-2.535-5.763-5.279-7.174-8.185-8.667a18.764 18.764 0 0 1-6.394-4.721c-2.876-3.335-8.333-21.552-5.19-24.276a2.571 2.571 0 0 1 1.714-0.676c1.687 0 3.143 1.706 3.694 2.44a32.446 32.446 0 0 1 4.869 11.458c0.106-0.094 0.219-0.186 0.34-0.274 1.709-1.237 4.633-0.715 8.479 1.516 4.115 2.395 8.38 6.248 9.785 8.344 1.754 2.612 3.29 7.777 4.3 11.48a0.485 0.485 0 0 1 0.059 0.23 0.468 0.468 0 0 1-0.468 0.467h-0.021c-2.442 0-9.854 1.908-12.377 2.924a0.463 0.463 0 0 1-0.175 0.035zm-18.485-37.683a1.641 1.641 0 0 0-1.1 0.446c-2.372 2.058 2.074 19.232 5.287 22.959a17.931 17.931 0 0 0 6.114 4.5c2.988 1.535 5.816 2.988 8.433 8.717a61.509 61.509 0 0 1 11.707-2.81c-0.724-2.639-2.295-8.132-4.048-10.742-1.319-1.969-5.536-5.761-9.478-8.057-3.412-1.977-6.1-2.554-7.458-1.565a2.028 2.028 0 0 0-0.745 0.87 0.459 0.459 0 0 1-0.5 0.3 0.47 0.47 0 0 1-0.405-0.413 30.977 30.977 0 0 0-4.857-12.133c-0.369-0.493-1.65-2.072-2.95-2.072z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path200",
  d: "m1177 1473.9h-5.819a0.468 0.468 0 0 1-0.467-0.469 6.3 6.3 0 0 1 6.286-6.288 0.469 0.469 0 0 1 0.469 0.469v5.819a0.469 0.469 0 0 1-0.469 0.469zm-5.33-0.937h4.863v-4.863a5.361 5.361 0 0 0-4.863 4.863z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path202",
  d: "m1177 1457.3a6.294 6.294 0 0 1-6.286-6.285 0.468 0.468 0 0 1 0.467-0.469h5.819a0.469 0.469 0 0 1 0.469 0.469v5.816a0.469 0.469 0 0 1-0.469 0.469zm-5.33-5.817a5.36 5.36 0 0 0 4.863 4.861v-4.861z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path204",
  d: "m1137.1 1457.3a0.468 0.468 0 0 1-0.466-0.469v-5.816a0.468 0.468 0 0 1 0.466-0.469h5.823a0.469 0.469 0 0 1 0.468 0.469 6.3 6.3 0 0 1-6.291 6.285zm0.47-5.817v4.861a5.362 5.362 0 0 0 4.865-4.861z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path206",
  d: "m1171.2 1473.9h-28.185a0.468 0.468 0 0 1-0.467-0.469 5.36 5.36 0 0 0-5.356-5.352 0.467 0.467 0 0 1-0.466-0.467v-10.792a0.467 0.467 0 0 1 0.466-0.467 5.358 5.358 0 0 0 5.356-5.349 0.468 0.468 0 0 1 0.467-0.469h28.185a0.468 0.468 0 0 1 0.469 0.469 5.356 5.356 0 0 0 5.35 5.349 0.468 0.468 0 0 1 0.469 0.467v10.789a0.468 0.468 0 0 1-0.469 0.467 5.358 5.358 0 0 0-5.35 5.352 0.468 0.468 0 0 1-0.469 0.472zm-27.734-0.937h27.281a6.3 6.3 0 0 1 5.8-5.8v-9.888a6.3 6.3 0 0 1-5.8-5.8h-27.285a6.3 6.3 0 0 1-5.8 5.8v9.888a6.3 6.3 0 0 1 5.804 5.8zm13.641-3.615a7.126 7.126 0 1 1 7.133-7.131 7.135 7.135 0 0 1-7.133 7.131zm0-13.317a6.19 6.19 0 1 0 6.195 6.186 6.192 6.192 0 0 0-6.195-6.186z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path208",
  d: "m1143 1473.9h-5.837a0.468 0.468 0 0 1-0.466-0.469v-5.822a0.468 0.468 0 0 1 0.466-0.469 6.3 6.3 0 0 1 6.29 6.168 0.539 0.539 0 0 1 0.017 0.12 0.47 0.47 0 0 1-0.47 0.472zm-5.367-0.937h4.865a5.363 5.363 0 0 0-4.865-4.863z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path210",
  d: "m1162.9 1501.4a0.459 0.459 0 0 1-0.122-0.015 0.47 0.47 0 0 1-0.332-0.574c0.573-2.121 2.31-8.575 4.318-11.588 1.766-2.635 7.893-7.911 12.745-9.8 2.426-0.945 4.285-0.964 5.527-0.059a2.986 2.986 0 0 1 1.07 1.3c1.235 3.028-4.283 6.634-8.543 9.083l-0.383 0.222a0.468 0.468 0 0 1-0.472-0.808l0.388-0.224c7.614-4.379 8.631-6.726 8.143-7.924a2.082 2.082 0 0 0-0.753-0.888c-1.2-0.877-3.186-0.39-4.64 0.174-4.612 1.8-10.642 6.97-12.3 9.447-1.925 2.885-3.632 9.227-4.194 11.311a0.466 0.466 0 0 1-0.452 0.343z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path212",
  d: "m1175.5 1504.4a0.453 0.453 0 0 1-0.189-0.04 0.467 0.467 0 0 1-0.239-0.617c2.662-6.065 5.551-7.55 8.608-9.122a17.891 17.891 0 0 0 6.109-4.5c1.428-1.653 3.418-6.736 4.728-12.087 1.375-5.608 1.6-9.977 0.568-10.871a1.588 1.588 0 0 0-1.277-0.437 4.678 4.678 0 0 0-2.767 2.053 30.612 30.612 0 0 0-4.855 12.143 0.471 0.471 0 0 1-0.512 0.417 0.466 0.466 0 0 1-0.418-0.513 31.249 31.249 0 0 1 5.036-12.609c0.5-0.67 1.842-2.253 3.416-2.422a2.54 2.54 0 0 1 1.99 0.66c1.951 1.686 0.461 8.814-0.272 11.8-1.115 4.553-3.134 10.4-4.929 12.475a18.67 18.67 0 0 1-6.388 4.72c-2.907 1.494-5.65 2.905-8.182 8.667a0.465 0.465 0 0 1-0.427 0.283z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path214",
  d: "m1173.2 1519.7a1.713 1.713 0 0 1-0.746-0.208 23.661 23.661 0 0 1-5.512-4.543 29.84 29.84 0 0 0-5.188-4.447c-0.238-0.143-0.476-0.277-0.711-0.407-0.978-0.549-1.9-1.066-2.219-1.963a1.713 1.713 0 0 1-0.1-0.616 16.776 16.776 0 0 1 1.154-4.368c0.094-0.256 0.173-0.484 0.235-0.667a2.645 2.645 0 0 1 2.838-2.008h0.087c2.54 0 10.062 1.946 12.663 2.993 1.417 0.569 2.212 1.2 2.505 2 0.378 0.985-0.734 4.155-2.473 8.878-0.6 1.639-1.123 3.052-1.317 3.778-0.195 0.775-0.405 1.578-1.216 1.578zm-10.159-18.291c-1.585 0.041-1.837 0.781-2.038 1.373-0.063 0.187-0.147 0.419-0.24 0.682a16.777 16.777 0 0 0-1.1 4.053 0.844 0.844 0 0 0 0.039 0.294c0.2 0.574 0.943 0.988 1.8 1.468 0.242 0.134 0.488 0.273 0.736 0.421a30.63 30.63 0 0 1 5.366 4.586 23.047 23.047 0 0 0 5.266 4.369 0.7 0.7 0 0 0 0.342 0.11 3.11 3.11 0 0 0 0.3-0.878c0.2-0.772 0.732-2.2 1.342-3.864 0.965-2.616 2.758-7.488 2.476-8.226-0.191-0.529-0.839-1.007-1.976-1.463-2.527-1.018-9.941-2.925-12.313-2.925z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path216",
  d: "m1171.7 1510.1a1.8 1.8 0 0 1-1.408-2.909 1.847 1.847 0 0 1 2.521-0.294 1.8 1.8 0 0 1-1.113 3.2zm0-2.65a0.88 0.88 0 0 0-0.682 0.328 0.839 0.839 0 0 0-0.176 0.62 0.858 0.858 0 0 0 1.516 0.446 0.847 0.847 0 0 0 0.191-0.642 0.829 0.829 0 0 0-0.316-0.568 0.86 0.86 0 0 0-0.529-0.184z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path218",
  d: "m1137.1 1490a0.479 0.479 0 0 1-0.236-0.064l-0.381-0.222c-4.246-2.444-9.75-6.046-8.533-9.085a0.469 0.469 0 1 1 0.87 0.349c-0.483 1.2 0.538 3.553 8.128 7.925l0.391 0.225a0.468 0.468 0 0 1-0.239 0.872z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path220",
  d: "m1151.1 1501.4a0.468 0.468 0 0 1-0.452-0.344c-0.632-2.324-2.313-8.5-4.2-11.312-1.319-1.969-5.536-5.761-9.478-8.057-3.448-2-6.1-2.553-7.458-1.565a2.028 2.028 0 0 0-0.745 0.87 0.469 0.469 0 1 1-0.874-0.339 2.931 2.931 0 0 1 1.068-1.29c2.155-1.561 5.8-0.037 8.479 1.516 4.115 2.395 8.38 6.248 9.785 8.344 1.771 2.637 3.32 7.876 4.329 11.587a0.467 0.467 0 0 1-0.329 0.574 0.427 0.427 0 0 1-0.125 0.016z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path222",
  d: "m1138.6 1504.4a0.469 0.469 0 0 1-0.43-0.28c-2.535-5.763-5.279-7.174-8.185-8.667a18.764 18.764 0 0 1-6.394-4.721c-2.876-3.335-8.333-21.552-5.19-24.276a2.547 2.547 0 0 1 1.989-0.66c1.576 0.169 2.916 1.752 3.419 2.424a31.6 31.6 0 0 1 5.043 12.594 0.493 0.493 0 0 1-0.467 0.5 0.441 0.441 0 0 1-0.467-0.437 31.012 31.012 0 0 0-4.855-12.093 4.7 4.7 0 0 0-2.772-2.055 1.6 1.6 0 0 0-1.279 0.436c-2.372 2.058 2.074 19.232 5.287 22.959a17.931 17.931 0 0 0 6.114 4.5c3.056 1.571 5.947 3.056 8.615 9.123a0.468 0.468 0 0 1-0.239 0.617 0.457 0.457 0 0 1-0.189 0.036z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path224",
  d: "m1140.9 1519.7c-0.794 0-1-0.764-1.216-1.573-0.193-0.745-0.726-2.2-1.347-3.874-1.721-4.671-2.821-7.806-2.453-8.789a4.061 4.061 0 0 1 2.516-2c2.6-1.046 10.12-2.992 12.661-2.992h0.081a2.669 2.669 0 0 1 2.842 2c0.07 0.209 0.158 0.461 0.259 0.747a16.787 16.787 0 0 1 1.123 4.3 1.787 1.787 0 0 1-0.088 0.608c-0.3 0.888-1.224 1.4-2.2 1.947-0.24 0.135-0.488 0.273-0.732 0.421a29.817 29.817 0 0 0-5.194 4.449 23.623 23.623 0 0 1-5.513 4.542 1.678 1.678 0 0 1-0.739 0.214zm10.222-18.292c-2.434 0-9.848 1.908-12.371 2.924-1.131 0.453-1.783 0.934-1.994 1.469-0.272 0.723 1.5 5.54 2.459 8.129 0.628 1.7 1.168 3.172 1.374 3.955a3 3 0 0 0 0.313 0.885 0.849 0.849 0 0 0 0.327-0.111 23.054 23.054 0 0 0 5.268-4.368 30.551 30.551 0 0 1 5.371-4.587c0.254-0.153 0.51-0.3 0.756-0.435 0.85-0.476 1.582-0.886 1.773-1.44a0.889 0.889 0 0 0 0.034-0.3 16.754 16.754 0 0 0-1.069-3.991c-0.1-0.294-0.193-0.551-0.261-0.757-0.218-0.618-0.468-1.328-1.977-1.369z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path226",
  d: "m1142.4 1510.1a1.8 1.8 0 0 1-1.4-0.672 1.811 1.811 0 0 1 0.286-2.529 1.848 1.848 0 0 1 2.518 0.293 1.794 1.794 0 0 1 0.378 1.334 1.745 1.745 0 0 1-0.667 1.184 1.763 1.763 0 0 1-1.115 0.39zm-0.01-2.65a0.838 0.838 0 0 0-0.528 0.183 0.87 0.87 0 0 0-0.139 1.209 0.862 0.862 0 0 0 0.672 0.323 0.853 0.853 0 0 0 0.535-0.19 0.813 0.813 0 0 0 0.317-0.559 0.866 0.866 0 0 0-0.857-0.966z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path228",
  d: "m1137.1 1468.1a0.467 0.467 0 0 1-0.466-0.467v-10.792a0.468 0.468 0 0 1 0.936 0v10.789a0.468 0.468 0 0 1-0.47 0.47z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path230",
  d: "m1171.2 1473.9h-28.185a0.469 0.469 0 0 1 0-0.937h28.185a0.469 0.469 0 1 1 0 0.937z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path232",
  d: "m1177 1468.1a0.467 0.467 0 0 1-0.467-0.467v-10.792a0.468 0.468 0 0 1 0.936 0v10.789a0.468 0.468 0 0 1-0.469 0.47z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path234",
  d: "m1171.2 1451.5h-28.185a0.469 0.469 0 0 1 0-0.937h28.185a0.469 0.469 0 1 1 0 0.937z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path236",
  d: "m1177 1457.3a6.294 6.294 0 0 1-6.286-6.285 0.468 0.468 0 0 1 0.467-0.469h5.819a0.469 0.469 0 0 1 0.469 0.469v5.816a0.469 0.469 0 0 1-0.469 0.469zm-5.33-5.817a5.36 5.36 0 0 0 4.863 4.861v-4.861z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path238",
  d: "m1137.1 1457.3a0.468 0.468 0 0 1-0.466-0.469v-5.816a0.468 0.468 0 0 1 0.466-0.469h5.823a0.469 0.469 0 0 1 0.468 0.469 6.3 6.3 0 0 1-6.291 6.285zm0.47-5.817v4.861a5.362 5.362 0 0 0 4.865-4.861z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path240",
  d: "m1143 1473.9h-5.837a0.468 0.468 0 0 1-0.466-0.469v-5.822a0.468 0.468 0 0 1 0.466-0.469 6.3 6.3 0 0 1 6.29 6.168 0.539 0.539 0 0 1 0.017 0.12 0.47 0.47 0 0 1-0.47 0.472zm-5.367-0.937h4.865a5.363 5.363 0 0 0-4.865-4.863z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path242",
  d: "m1177 1473.9h-5.819a0.468 0.468 0 0 1-0.467-0.469 6.3 6.3 0 0 1 6.286-6.288 0.469 0.469 0 0 1 0.469 0.469v5.819a0.469 0.469 0 0 1-0.469 0.469zm-5.33-0.937h4.863v-4.863a5.361 5.361 0 0 0-4.863 4.863z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path244",
  d: "m1157.1 1469.3a7.126 7.126 0 1 1 7.133-7.131 7.135 7.135 0 0 1-7.133 7.131zm0-13.317a6.19 6.19 0 1 0 6.195 6.186 6.192 6.192 0 0 0-6.195-6.186z"
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "i1_8"
}, /*#__PURE__*/React.createElement("g", {
  id: "g114",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path110",
  d: "m373.98 1982.8a74.386 74.386 0 1 1-74.383 74.389 74.385 74.385 0 0 1 74.383-74.389z",
  fill: "url(#j)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "path112",
  d: "m373.98 2127.9a70.684 70.684 0 1 1 70.682-70.683 70.763 70.763 0 0 1-70.682 70.683zm0-129.37a58.684 58.684 0 1 0 58.682 58.685 58.75 58.75 0 0 0-58.682-58.685z",
  fill: "#fee7a6"
})), /*#__PURE__*/React.createElement("g", {
  id: "g266",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path248",
  d: "m398.4 2091.3h-52.1a0.632 0.632 0 0 1-0.633-0.633v-66.734a0.632 0.632 0 0 1 0.633-0.632h12.6a0.632 0.632 0 0 1 0.633 0.632v7.8h25.642v-7.8a0.632 0.632 0 0 1 0.633-0.632h12.6a0.633 0.633 0 0 1 0.634 0.632v66.731a0.633 0.633 0 0 1-0.642 0.636zm-51.468-1.266h50.836v-65.47h-11.332v7.8a0.633 0.633 0 0 1-0.632 0.634h-26.904a0.634 0.634 0 0 1-0.633-0.634v-7.8h-11.335z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path250",
  d: "m393.7 2086.6h-42.7a0.635 0.635 0 0 1-0.634-0.633v-57.348a0.634 0.634 0 0 1 0.634-0.634h7.9a0.633 0.633 0 0 1 0.633 0.634v3.108h25.642v-3.108a0.633 0.633 0 0 1 0.633-0.634h7.9a0.633 0.633 0 0 1 0.633 0.634v57.348a0.634 0.634 0 0 1-0.641 0.633zm-42.075-1.267h41.442v-56.077h-6.635v3.106a0.633 0.633 0 0 1-0.632 0.634h-26.9a0.634 0.634 0 0 1-0.633-0.634v-3.106h-6.634z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path252",
  d: "m385.8 2033h-26.9a0.634 0.634 0 0 1-0.633-0.634v-9.658a0.634 0.634 0 0 1 0.633-0.633h3.649v-4.132a0.633 0.633 0 0 1 0.633-0.631h18.345a0.633 0.633 0 0 1 0.632 0.631v4.132h3.641a0.633 0.633 0 0 1 0.632 0.633v9.658a0.633 0.633 0 0 1-0.632 0.634zm-26.275-1.265h25.642v-8.394h-3.648a0.633 0.633 0 0 1-0.633-0.633v-4.131h-17.076v4.131a0.632 0.632 0 0 1-0.632 0.633h-3.649z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path254",
  d: "m372.35 2028.1a3.323 3.323 0 1 1 3.322-3.325 3.328 3.328 0 0 1-3.322 3.325zm0-5.38a2.057 2.057 0 1 0 2.056 2.055 2.06 2.06 0 0 0-2.056-2.055z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path256",
  d: "m386 2048.9h-27.293a0.633 0.633 0 1 1 0-1.266h27.293a0.633 0.633 0 1 1 0 1.266z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path258",
  d: "m365.87 2055.3h-7.163a0.633 0.633 0 1 1 0-1.266h7.163a0.633 0.633 0 1 1 0 1.266z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path260",
  d: "m377.92 2061.7h-19.217a0.633 0.633 0 1 1 0-1.266h19.217a0.633 0.633 0 1 1 0 1.266z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path262",
  d: "m381.45 2068.1h-22.741a0.633 0.633 0 1 1 0-1.266h22.741a0.633 0.633 0 1 1 0 1.266z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path264",
  d: "m386 2074.5h-27.293a0.633 0.633 0 1 1 0-1.265h27.293a0.633 0.633 0 1 1 0 1.265z"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "i1_5"
}, /*#__PURE__*/React.createElement("g", {
  id: "g126",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path122",
  d: "m1160.2 1724.8a74.385 74.385 0 1 1-74.384 74.387 74.385 74.385 0 0 1 74.384-74.387z",
  fill: "url(#l)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "path124",
  d: "m1160.2 1869.8a70.684 70.684 0 1 1 70.683-70.683 70.763 70.763 0 0 1-70.683 70.683zm0-129.37a58.684 58.684 0 1 0 58.683 58.685 58.75 58.75 0 0 0-58.683-58.685z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "g296",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path268",
  d: "m1147.3 1792.1a0.615 0.615 0 0 1-0.451-0.193 0.624 0.624 0 0 1 0.022-0.883l4.841-4.607a0.62526 0.62526 0 1 1 0.863 0.905l-4.845 4.608a0.618 0.618 0 0 1-0.43 0.17z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path270",
  d: "m1147.3 1792.1a0.618 0.618 0 0 1-0.519-0.279l-1.861-2.787a0.62515 0.62515 0 0 1 1.04-0.694l1.861 2.789a0.624 0.624 0 0 1-0.521 0.971z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path272",
  d: "m1145.9 1818a0.625 0.625 0 0 1-0.43-1.079l6.645-6.314a0.626 0.626 0 0 1 0.86 0.909l-6.644 6.312a0.631 0.631 0 0 1-0.431 0.172z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path274",
  d: "m1152.6 1818a0.623 0.623 0 0 1-0.429-0.172l-6.645-6.312a0.62602 0.62602 0 1 1 0.861-0.909l6.644 6.314a0.626 0.626 0 0 1-0.431 1.079z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path276",
  d: "m1185 1834.7h-51.865a0.625 0.625 0 0 1-0.624-0.625v-65.106a0.624 0.624 0 0 1 0.624-0.625h14.993a0.624 0.624 0 0 1 0.624 0.625v7.231h20.63v-7.231a0.625 0.625 0 0 1 0.626-0.625h14.992a0.625 0.625 0 0 1 0.625 0.625v65.106a0.625 0.625 0 0 1-0.625 0.625zm-51.239-1.25h50.614v-63.856h-13.743v7.231a0.624 0.624 0 0 1-0.624 0.625h-21.88a0.624 0.624 0 0 1-0.626-0.625v-7.231h-13.741z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path278",
  d: "m1181 1829.7h-43.862a0.624 0.624 0 0 1-0.625-0.625v-55.063a0.624 0.624 0 0 1 0.625-0.624h10.991a0.623 0.623 0 0 1 0.624 0.624v2.21h20.63v-2.21a0.625 0.625 0 0 1 0.626-0.624h10.991a0.624 0.624 0 0 1 0.625 0.624v55.063a0.625 0.625 0 0 1-0.625 0.625zm-43.238-1.249h42.613v-53.814h-9.742v2.209a0.624 0.624 0 0 1-0.624 0.625h-21.88a0.624 0.624 0 0 1-0.626-0.625v-2.209h-9.741z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path280",
  d: "m1156 1795.2h-13.44a0.625 0.625 0 0 1-0.626-0.624v-11.574a0.626 0.626 0 0 1 0.626-0.625h13.44a0.626 0.626 0 0 1 0.625 0.625v11.574a0.624 0.624 0 0 1-0.625 0.624zm-12.814-1.25h12.188v-10.323h-12.188z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path282",
  d: "m1156.9 1821.4h-15.234a0.624 0.624 0 0 1-0.624-0.625v-13.117a0.624 0.624 0 0 1 0.624-0.625h15.234a0.626 0.626 0 0 1 0.625 0.625v13.117a0.625 0.625 0 0 1-0.625 0.625zm-14.608-1.25h13.983v-11.867h-13.983z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path284",
  d: "m1176.5 1786.1h-15.878a0.6255 0.6255 0 1 1 0-1.251h15.88a0.6255 0.6255 0 1 1 0 1.251z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path286",
  d: "m1170.2 1791.9h-9.64a0.625 0.625 0 1 1 0-1.25h9.642a0.625 0.625 0 1 1 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path288",
  d: "m1176.5 1812.4h-15.878a0.625 0.625 0 1 1 0-1.25h15.88a0.625 0.625 0 1 1 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path290",
  d: "m1170.2 1818.1h-9.64a0.625 0.625 0 1 1 0-1.25h9.642a0.625 0.625 0 0 1 0 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path292",
  d: "m1170 1777.4h-21.88a0.624 0.624 0 0 1-0.626-0.625v-10.21a0.624 0.624 0 0 1 0.626-0.625h5.766a5.246 5.246 0 0 1 10.346 0h5.768a0.624 0.624 0 0 1 0.624 0.625v10.206a0.624 0.624 0 0 1-0.624 0.629zm-21.256-1.25h20.63v-8.957h-5.7a0.624 0.624 0 0 1-0.624-0.59 4 4 0 0 0-7.979 0 0.624 0.624 0 0 1-0.623 0.59h-5.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path294",
  d: "m1159.1 1775a3.116 3.116 0 1 1 3.114-3.115 3.121 3.121 0 0 1-3.114 3.115zm0-4.981a1.865 1.865 0 1 0 1.864 1.866 1.869 1.869 0 0 0-1.864-1.866z"
})));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "i1_6"
}, /*#__PURE__*/React.createElement("g", {
  id: "g120",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path116",
  d: "m975.93 1983.4a74.385 74.385 0 1 1-74.385 74.387 74.384 74.384 0 0 1 74.385-74.387z",
  fill: "url(#k)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "path118",
  d: "m975.93 2128.5a70.684 70.684 0 1 1 70.681-70.683 70.764 70.764 0 0 1-70.681 70.683zm0-129.37a58.684 58.684 0 1 0 58.681 58.685 58.75 58.75 0 0 0-58.681-58.684z",
  fill: "#5d752e"
})), /*#__PURE__*/React.createElement("g", {
  id: "g322",
  transform: "translate(-152,-1027)",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path298",
  d: "m943.84 2070.4a0.57 0.57 0 0 1-0.287-0.075 0.586 0.586 0 0 1-0.266-0.347l-3.894-14.551a0.573 0.573 0 0 1 0.406-0.7l5.978-1.6a0.576 0.576 0 0 1 0.7 0.4l3.9 14.551a0.573 0.573 0 0 1-0.4 0.7l-5.983 1.6a0.462 0.462 0 0 1-0.154 0.022zm-3.2-14.718 3.6 13.447 4.877-1.306-3.6-13.446z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path300",
  d: "m979.95 2068.1h-0.029l-30.508-0.773a0.566 0.566 0 0 1-0.537-0.423l-3.13-11.692a0.567 0.567 0 0 1 0.252-0.637l26.03-15.917a0.574 0.574 0 0 1 0.6 0 0.565 0.565 0 0 1 0.261 0.54 45.815 45.815 0 0 0 7.438 27.9 0.565 0.565 0 0 1 0.193 0.427 0.571 0.571 0 0 1-0.57 0.575zm-30.082-1.906 28.96 0.733a47.642 47.642 0 0 1-7.159-26.712l-24.711 15.112z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path302",
  d: "m988.54 2074.1c-5.523 0-12-8.6-15.053-20-3.4-12.663-1.505-23.807 4.318-25.368a5.281 5.281 0 0 1 1.359-0.177c5.536 0 12.005 8.6 15.05 20 3.4 12.664 1.506 23.808-4.3 25.371a5.322 5.322 0 0 1-1.374 0.174zm-9.376-44.4a4.133 4.133 0 0 0-1.062 0.138c-5.025 1.348-6.634 12.325-3.509 23.968 2.88 10.741 9.006 19.154 13.947 19.154a4.166 4.166 0 0 0 1.074-0.139c5.021-1.349 6.623-12.326 3.5-23.971-2.871-10.742-8.996-19.152-13.95-19.152z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path304",
  d: "m992.43 2072.1a0.554 0.554 0 0 1-0.2-0.036c-5.048-1.861-10.213-9.73-12.856-19.579s-2.1-19.25 1.347-23.4a0.571 0.571 0 0 1 0.635-0.17c5.046 1.858 10.216 9.732 12.855 19.591s2.1 19.257-1.342 23.386a0.569 0.569 0 0 1-0.439 0.208zm-11.082-41.955c-2.94 3.991-3.307 12.941-0.864 22.044s7.229 16.666 11.76 18.649c2.939-3.974 3.307-12.923 0.865-22.033s-7.231-16.679-11.761-18.66z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path306",
  d: "m980.69 2055.5a0.563 0.563 0 0 1-0.544-0.4c-0.307-0.968-0.564-1.825-0.774-2.624-0.233-0.85-0.439-1.724-0.639-2.664a0.575 0.575 0 0 1 0.327-0.637 13.731 13.731 0 0 1 5.434-1.219c2.3 0 3.871 0.756 4.216 2.021 0.259 0.971-0.254 2.049-1.446 3.032a11.662 11.662 0 0 1-4.309 2.085 14.266 14.266 0 0 1-2.213 0.4zm-0.739-5.467c0.164 0.751 0.334 1.457 0.526 2.147 0.173 0.66 0.376 1.356 0.619 2.128a14.061 14.061 0 0 0 1.564-0.316 10.482 10.482 0 0 0 3.875-1.864c0.814-0.668 1.2-1.344 1.066-1.849-0.19-0.706-1.437-1.179-3.107-1.179a11.9 11.9 0 0 0-3.037 0.429 11.572 11.572 0 0 0-1.506 0.504z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path308",
  d: "m964.05 2087.5a0.575 0.575 0 0 1-0.5-0.3l-11.071-20.072a0.575 0.575 0 0 1 0.02-0.582 0.585 0.585 0 0 1 0.511-0.266l6.79 0.34a0.569 0.569 0 0 1 0.469 0.292l9.7 17.422a0.581 0.581 0 0 1 0.039 0.465 0.566 0.566 0 0 1-0.315 0.34l-5.416 2.311a0.541 0.541 0 0 1-0.227 0.05zm-10.074-20.023 10.324 18.723 4.357-1.86-9.232-16.591z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path310",
  d: "m952.74 2060.2a0.571 0.571 0 0 1-0.144-1.123l17.909-4.806a0.57208 0.57208 0 1 1 0.293 1.106l-17.907 4.8a0.56 0.56 0 0 1-0.151 0.023z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path312",
  d: "m1001 2045.9a0.571 0.571 0 0 1-0.15-1.122l5.92-1.585a0.573 0.573 0 0 1 0.7 0.406 0.565 0.565 0 0 1-0.406 0.7l-5.915 1.583a0.551 0.551 0 0 1-0.149 0.018z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path314",
  d: "m1008.4 2053.2h-6.112a0.572 0.572 0 1 1 0-1.144h6.112a0.572 0.572 0 1 1 0 1.144z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path316",
  d: "m1007.5 2062.1a0.531 0.531 0 0 1-0.146-0.019l-5.908-1.583a0.572 0.572 0 1 1 0.295-1.1l5.906 1.584a0.571 0.571 0 0 1-0.147 1.123z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path318",
  d: "m993.28 2033.6a0.583 0.583 0 0 1-0.4-0.169 0.575 0.575 0 0 1 0-0.808l4.328-4.326a0.571 0.571 0 0 1 0.809 0 0.582 0.582 0 0 1 0 0.809l-4.327 4.325a0.582 0.582 0 0 1-0.41 0.169z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path320",
  d: "m997.97 2039.2a0.571 0.571 0 0 1-0.284-1.068l5.305-3.057a0.57212 0.57212 0 0 1 0.572 0.991l-5.306 3.057a0.552 0.552 0 0 1-0.287 0.077z"
})));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "i1_7"
}, /*#__PURE__*/React.createElement("g", {
  id: "g108",
  transform: "translate(-152,-1027)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path104",
  d: "m671.53 2078.9a74.386 74.386 0 1 1-74.385 74.388 74.386 74.386 0 0 1 74.385-74.388z",
  fill: "url(#linearGradient2416)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "path106",
  d: "m671.53 2223.9a70.684 70.684 0 1 1 70.682-70.683 70.763 70.763 0 0 1-70.682 70.683zm0-129.37a58.684 58.684 0 1 0 58.682 58.686 58.751 58.751 0 0 0-58.682-58.686z",
  fill: "#f4c478"
})), /*#__PURE__*/React.createElement("g", {
  id: "g368",
  transform: "translate(-152,-1027)",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path324",
  d: "m648.82 2126.2a6.315 6.315 0 1 1 6.323-6.312 6.321 6.321 0 0 1-6.323 6.312zm0-11.325a5.009 5.009 0 1 0 5.018 5.013 5.017 5.017 0 0 0-5.018-5.013z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path326",
  d: "m657.48 2145.7a2.539 2.539 0 0 1-2.543-2.533v-2.277a0.655 0.655 0 1 1 1.309 0v2.277a1.246 1.246 0 0 0 1.234 1.23 1.311 1.311 0 0 0 1.237-1.281v-8.862a5.39 5.39 0 0 0-5.387-5.382h-8.714a5.388 5.388 0 0 0-5.385 5.382v8.925a1.227 1.227 0 0 0 1.235 1.218 1.248 1.248 0 0 0 1.236-1.23v-2.277a0.652 0.652 0 1 1 1.3 0v2.277a2.541 2.541 0 0 1-5.082 0.012v-8.925a6.7 6.7 0 0 1 6.692-6.687h8.714a6.7 6.7 0 0 1 6.693 6.687v8.925a2.6 2.6 0 0 1-2.539 2.521z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path328",
  d: "m655.59 2149.2h-13.242a0.651 0.651 0 0 1-0.651-0.653v-10.135a0.652 0.652 0 1 1 1.3 0v9.484h11.933v-9.484a0.655 0.655 0 0 1 1.309 0v10.135a0.651 0.651 0 0 1-0.649 0.653z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path330",
  d: "m648.97 2140.1a0.652 0.652 0 0 1-0.653-0.655v-7.773h-1.5a0.653 0.653 0 1 1 0-1.306h4.3a0.653 0.653 0 1 1 0 1.306h-1.5v7.773a0.652 0.652 0 0 1-0.647 0.655z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path332",
  d: "m685.82 2169.9a6.316 6.316 0 1 1 6.322-6.311 6.321 6.321 0 0 1-6.322 6.311zm0-11.322a5.009 5.009 0 1 0 5.015 5.011 5.017 5.017 0 0 0-5.015-5.011z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path334",
  d: "m682.01 2163.9a6.253 6.253 0 0 1-2.036-0.337 0.652 0.652 0 1 1 0.421-1.234 5.006 5.006 0 0 0 1.615 0.264 4.95 4.95 0 0 0 4.012-2.007 0.657 0.657 0 0 1 0.931-0.122 5.135 5.135 0 0 0 4.217 1 0.66 0.66 0 0 1 0.772 0.51 0.651 0.651 0 0 1-0.507 0.769 6.455 6.455 0 0 1-4.775-0.885 6.341 6.341 0 0 1-4.65 2.042z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path336",
  d: "m694.48 2189.4a2.539 2.539 0 0 1-2.532-2.542v-2.273a0.652 0.652 0 0 1 1.3 0v2.273a1.234 1.234 0 0 0 1.228 1.236 1.305 1.305 0 0 0 1.241-1.28v-8.864a5.389 5.389 0 0 0-5.382-5.38h-8.72a5.385 5.385 0 0 0-5.379 5.38v8.925a1.223 1.223 0 0 0 1.224 1.219 1.237 1.237 0 0 0 1.238-1.236v-2.273a0.653 0.653 0 0 1 1.306 0v2.273a2.5375 2.5375 0 0 1-5.075 0.017v-8.925a6.7 6.7 0 0 1 6.686-6.686h8.72a6.7 6.7 0 0 1 6.688 6.686v8.925a2.61 2.61 0 0 1-2.543 2.525z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path338",
  d: "m692.6 2193h-13.25a0.651 0.651 0 0 1-0.651-0.653v-10.139a0.653 0.653 0 1 1 1.306 0v9.483h11.942v-9.483a0.652 0.652 0 1 1 1.3 0v10.136a0.651 0.651 0 0 1-0.647 0.656z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path340",
  d: "m685.97 2183.9a0.654 0.654 0 0 1-0.652-0.653v-7.776h-1.487a0.652 0.652 0 1 1 0-1.3h4.287a0.652 0.652 0 1 1 0 1.3h-1.494v7.776a0.655 0.655 0 0 1-0.654 0.653z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path342",
  d: "m672.62 2155.3a0.644 0.644 0 0 1-0.318-0.083 0.654 0.654 0 0 1-0.329-0.664l1.32-9h-5.818a0.65 0.65 0 0 1-0.651-0.653v-23.865a0.649 0.649 0 0 1 0.651-0.651h37.005a0.654 0.654 0 0 1 0.654 0.651v23.865a0.655 0.655 0 0 1-0.654 0.653h-20.021l-11.418 9.593a0.652 0.652 0 0 1-0.421 0.154zm-4.492-11.054h5.92a0.655 0.655 0 0 1 0.491 0.226 0.665 0.665 0 0 1 0.154 0.524l-1.179 8.047 10.291-8.644a0.655 0.655 0 0 1 0.42-0.154h19.6v-22.557h-35.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path344",
  d: "m690.41 2125.7h-16.306a0.652 0.652 0 1 1 0-1.3h16.308a0.652 0.652 0 1 1 0 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path346",
  d: "m697.85 2125.7h-4.1a0.652 0.652 0 1 1 0-1.3h4.1a0.652 0.652 0 1 1 0 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path348",
  d: "m645.09 2120.2a6.24 6.24 0 0 1-2.034-0.337 0.653 0.653 0 1 1 0.423-1.235 5 5 0 0 0 5.625-1.743 0.65 0.65 0 0 1 0.438-0.254 0.625 0.625 0 0 1 0.491 0.137 5.016 5.016 0 0 0 3.149 1.108 4.942 4.942 0 0 0 1.051-0.107 0.652 0.652 0 0 1 0.276 1.274 6.226 6.226 0 0 1-1.327 0.137 6.383 6.383 0 0 1-3.443-1.019 6.257 6.257 0 0 1-4.649 2.039z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path350",
  d: "m668.94 2184.5h-20.793a0.653 0.653 0 0 1-0.655-0.653v-32.583a0.653 0.653 0 1 1 1.306 0v31.93h20.142a0.653 0.653 0 0 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path352",
  d: "m697.85 2129.4h-16.316a0.653 0.653 0 0 1 0-1.306h16.316a0.653 0.653 0 1 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path354",
  d: "m678.2 2129.4h-4.1a0.653 0.653 0 1 1 0-1.306h4.1a0.653 0.653 0 0 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path356",
  d: "m690.41 2133.1h-16.306a0.653 0.653 0 1 1 0-1.306h16.308a0.653 0.653 0 0 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path358",
  d: "m697.85 2133.1h-4.1a0.653 0.653 0 1 1 0-1.306h4.1a0.653 0.653 0 1 1 0 1.306z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path360",
  d: "m697.85 2136.9h-16.316a0.6535 0.6535 0 0 1 0-1.307h16.316a0.6535 0.6535 0 1 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path362",
  d: "m678.2 2136.9h-4.1a0.6535 0.6535 0 1 1 0-1.307h4.1a0.6535 0.6535 0 0 1 0 1.307z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path364",
  d: "m690.41 2140.6h-16.306a0.654 0.654 0 1 1 0-1.308h16.308a0.654 0.654 0 0 1 0 1.308z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path366",
  d: "m697.85 2140.6h-4.1a0.654 0.654 0 1 1 0-1.308h4.1a0.654 0.654 0 1 1 0 1.308z"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "g374",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path370",
  d: "m438.85 1204.3a0.739 0.739 0 0 1-0.81-1.154 137.66 137.66 0 0 1 147.62-48.868 0.742 0.742 0 0 1 0.507 0.917 0.75 0.75 0 0 1-0.919 0.507 136.18 136.18 0 0 0-146.02 48.344 0.727 0.727 0 0 1-0.368 0.254z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path372",
  d: "m585.4 1151.3 5.119 5.327-7.172 1.77z"
}));

var _ref18 = /*#__PURE__*/React.createElement("text", {
  id: "text378",
  x: 118.684,
  y: 107.232,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan376",
  x: 118.684,
  y: 107.232
}, "1."));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "g392",
  transform: "translate(-152,-1027)",
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text386",
  transform: "translate(789.31 1062.4)",
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan380",
  x: 0,
  y: 0
}, "Tutvume"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan384",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan382",
  x: 0,
  y: 21.6
}, "objektiga"))), /*#__PURE__*/React.createElement("text", {
  id: "text390",
  transform: "translate(746.18 1083.2)",
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan388",
  x: 0,
  y: 0
}, "2.")));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "g398",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path394",
  d: "m743.26 1150.8a0.74 0.74 0 0 1 0.023-1.41 137.66 137.66 0 0 1 148.15 47.229 0.742 0.742 0 0 1-0.129 1.04 0.75 0.75 0 0 1-1.041-0.13 136.18 136.18 0 0 0-146.55-46.721 0.717 0.717 0 0 1-0.449-0.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path396",
  d: "m893.03 1194 1.01 7.319-6.843-2.784z"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "g404",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path400",
  d: "m1022.6 1288.1a0.739 0.739 0 0 1 0.848-1.126 137.66 137.66 0 0 1 92.094 125.29 0.74 0.74 0 0 1-0.715 0.765 0.75 0.75 0 0 1-0.766-0.718 136.17 136.17 0 0 0-91.1-123.94 0.717 0.717 0 0 1-0.361-0.272z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path402",
  d: "m1118.3 1411.1-3.484 6.516-3.9-6.275z"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "g410",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path406",
  d: "m1164.4 1562.7a0.739 0.739 0 0 1 1.348-0.412 137.66 137.66 0 0 1 0.864 155.49 0.742 0.742 0 0 1-1.228-0.832 136.18 136.18 0 0 0-0.853-153.82 0.72 0.72 0 0 1-0.131-0.428z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path408",
  d: "m1169.6 1718.5-6.649 3.223 0.533-7.368z"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  id: "g416",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path412",
  d: "m1117.8 1866.8a0.739 0.739 0 0 1 1.332 0.458 137.66 137.66 0 0 1-90.7 126.3 0.7433 0.7433 0 0 1-0.5-1.4 136.18 136.18 0 0 0 89.723-124.94 0.7 0.7 0 0 1 0.145-0.418z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path414",
  d: "m1030.5 1995.8-7.273-1.3 4.762-5.647z"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "g422",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path418",
  d: "m899.58 2088.9a0.739 0.739 0 0 1 0.809 1.154 137.66 137.66 0 0 1-147.62 48.872 0.742 0.742 0 0 1 0.413-1.425 136.18 136.18 0 0 0 146.03-48.345 0.7 0.7 0 0 1 0.367-0.256z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path420",
  d: "m753.03 2141.9-5.119-5.326 7.171-1.77z"
}));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "g428",
  transform: "translate(-152,-1027)",
  fill: "#bcbec0"
}, /*#__PURE__*/React.createElement("path", {
  id: "path424",
  d: "m592.96 2135.2a0.739 0.739 0 0 1-0.025 1.409 137.65 137.65 0 0 1-148.15-47.229 0.742 0.742 0 0 1 1.171-0.91 136.18 136.18 0 0 0 146.56 46.722 0.709 0.709 0 0 1 0.449 0.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path426",
  d: "m443.2 2092-1.013-7.318 6.843 2.784z"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text436",
  x: 1146.238,
  y: 440.70099,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan430",
  x: 1146.238,
  y: 440.70099
}, "S\xF5lmime"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan434",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan432",
  x: 1146.238,
  y: 462.30099
}, "lepingud"))), /*#__PURE__*/React.createElement("text", {
  id: "text440",
  x: 907.68597,
  y: 177.355,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan438",
  x: 907.68597,
  y: 177.355
}, "3.")), /*#__PURE__*/React.createElement("text", {
  id: "text448",
  x: 952.30701,
  y: 155.339,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan442",
  x: 952.30701,
  y: 155.339
}, "Lepime kokku"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan446",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan444",
  x: 952.30701,
  y: 176.939
}, "hinnas"))), /*#__PURE__*/React.createElement("text", {
  id: "text452",
  x: 1104.184,
  y: 463.05399,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan450",
  x: 1104.184,
  y: 463.05399
}, "4.")));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  id: "g466",
  transform: "translate(-152,-1027)",
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text460",
  transform: "translate(1296.1 1806)",
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan454",
  x: 0,
  y: 0
}, "Kontrollime \xFCle"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan458",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan456",
  x: 0,
  y: 21.6
}, "andmed"))), /*#__PURE__*/React.createElement("text", {
  id: "text464",
  transform: "translate(1253.2 1826.9)",
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan462",
  x: 0,
  y: 0
}, "5.")));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  id: "g480",
  transform: "translate(-152,-1027)",
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text474",
  transform: "translate(1099.2 2104.4)",
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan468",
  x: 0,
  y: 0
}, "Teavitame"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan472",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan470",
  x: 0,
  y: 21.6
}, "ostjaid"))), /*#__PURE__*/React.createElement("text", {
  id: "text478",
  transform: "translate(1055.5 2125.7)",
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan476",
  x: 0,
  y: 0
}, "6.")));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  id: "g494",
  transform: "translate(-152,-1027)",
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text488",
  transform: "translate(788.31 2244.4)",
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan482",
  x: 0,
  y: 0
}, "Hoiame Sind"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan486",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan484",
  x: 0,
  y: 21.6
}, "kursis"))), /*#__PURE__*/React.createElement("text", {
  id: "text492",
  transform: "translate(745.21 2265.9)",
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan490",
  x: 0,
  y: 0
}, "7.")));

var _ref30 = /*#__PURE__*/React.createElement("text", {
  id: "text498",
  x: 118.684,
  y: 1174.881,
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontSize: "48px",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan496",
  x: 118.684,
  y: 1174.881
}, "8."));

var SvgIllustration11 = function SvgIllustration11(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg501",
    width: 1566,
    height: 1299,
    viewBox: "0 0 1566 1299",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustration11, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration1_1.9e30abdb.svg";
export { ForwardRef as ReactComponent };